export default __webpack_public_path__ + "static/fc51127f-231a-46ef-9b37-939fd3d21dfa-50cd3bbe3183d302cf8db09edb2806aa.woff2";